import { render } from "./Center.vue?vue&type=template&id=6fdb84b5"
import script from "./Center.vue?vue&type=script&lang=js"
export * from "./Center.vue?vue&type=script&lang=js"
script.render = render

export default script